import { render, staticRenderFns } from "./getstartconfirmView.vue?vue&type=template&id=7f34914c&"
import script from "./getstartconfirmView.vue?vue&type=script&lang=js&"
export * from "./getstartconfirmView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports